import { render, staticRenderFns } from "./GeneralGraph.vue?vue&type=template&id=647f2ffc&scoped=true"
import script from "./GeneralGraph.vue?vue&type=script&lang=js"
export * from "./GeneralGraph.vue?vue&type=script&lang=js"
import style0 from "./GeneralGraph.vue?vue&type=style&index=0&id=647f2ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647f2ffc",
  null
  
)

export default component.exports